import { render } from "./FindALawyer.vue?vue&type=template&id=6b31f1b0"
import script from "./FindALawyer.vue?vue&type=script&lang=js"
export * from "./FindALawyer.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__